module.exports = __webpack_public_path__ + "static/media/climate_workplacePollutants_2_overlandPollutants.43337238.jpg";